import {
  neutralDark,
  neutralLight,
  primaryLight,
} from '@crehana/tailwindcss/colors';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';

import { SIZE_ICON_MODERN_MODAL, type WrapperIconColor } from './types';

export const WrapperModalContent = styled.div`
  width: 562px;
`;

export const WrapperModalContentHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 24px 12px;
  border-bottom: 1px solid ${neutralLight['400']};
`;

type Opacity = '100' | '200' | '300' | '400' | '500' | '600';

const getSize = (size: SIZE_ICON_MODERN_MODAL) => ({
  position: size === SIZE_ICON_MODERN_MODAL.S ? '4px' : '6px',
  'external-width': size === SIZE_ICON_MODERN_MODAL.S ? '40px' : '56px',
  'internal-width': size === SIZE_ICON_MODERN_MODAL.S ? '32px' : '44px',
});

const getColor = (color: WrapperIconColor | undefined, opacity: Opacity) => {
  if (color) {
    return color[opacity];
  }
  return primaryLight[opacity];
};

export const WrapperIcon = styled.div<{
  isDark?: boolean;
  firstOpacity?: Opacity;
  secondOpacity?: Opacity;
  type: SIZE_ICON_MODERN_MODAL;
  customColor?: WrapperIconColor;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ type }) => getSize(type)['external-width']};
  height: ${({ type }) => getSize(type)['external-width']};
  border-radius: 50%;
  background: ${({ customColor, firstOpacity }) =>
    getColor(customColor, firstOpacity || '100')};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: ${({ type }) => getSize(type)['internal-width']};
    height: ${({ type }) => getSize(type)['internal-width']};
    border-radius: 50%;
    background: ${({ customColor, secondOpacity }) =>
      getColor(customColor, secondOpacity || '200')};
    top: ${({ type }) => getSize(type)['position']};
    left: ${({ type }) => getSize(type)['position']};
    z-index: 9999;
  }

  & > svg {
    z-index: 99999;
  }
`;

export const WrapperModalButtons = styled.div<{
  isDark?: boolean;
  center?: boolean;
}>`
  display: flex;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-end')};
  align-items: center;
  padding: 20px 24px;
  gap: 8px;
  border-top: 1px solid
    ${({ isDark }) => (isDark ? neutralDark['600'] : neutralLight['400'])};
  background: ${({ isDark }) =>
    isDark ? neutralDark['700'] : neutralLight['300']};
`;
